export const getToday = () => {
	let newDate = new Date()
	const date = newDate.getDate()
	const month = newDate.getMonth() + 1
	const year = newDate.getFullYear()
	return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : date}`
}